import { render, staticRenderFns } from "./getClassificationMotiveDialog.vue?vue&type=template&id=799fc352&"
import script from "./getClassificationMotiveDialog.vue?vue&type=script&lang=js&"
export * from "./getClassificationMotiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports